import React from 'react';

/**
 * Mobile Opponent Drones Component
 * Positioned at top-right corner
 */
export const MobileOpponentDrones = ({
  opponent
}) => {
  return (
    <div
      className="opponent-drone-zone-mobile"
      style={{
        position: "absolute",
        top: "5px",
        right: "5px",
        zIndex: 1002,
        display: "flex",
        gap: "2px",
        flexDirection: "row",
        transform: "scale(0.35)",
        transformOrigin: "top right"
      }}
    >
      {opponent.drones?.filter(drone => !drone.markedForRemoval).map((drone, index) => (
        <div
          key={`mobile-opponent-drone-${index}`}
          style={{
            width: '80px',
            height: '60px',
            backgroundColor: '#333',
            border: '2px solid #a02c2c',
            borderRadius: '4px',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'visible'
          }}
        >
          <img 
            src={`/images/drones/${drone.image || 'default_drone.png'}`}
            alt={drone.name}
            style={{
              width: '70px',
              height: '50px',
              objectFit: 'contain'
            }}
          />
          {drone.charges !== undefined && (
            <div style={{
              position: 'absolute',
              top: '-8px',
              right: '-8px',
              backgroundColor: '#a02c2c',
              color: 'white',
              borderRadius: '50%',
              width: '20px',
              height: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '11px',
              fontWeight: 'bold'
            }}>
              {drone.charges}
            </div>
          )}
        </div>
      ))}
      {/* Empty drone slots */}
      {Array.from({ length: 4 - (opponent.drones?.filter(drone => !drone.markedForRemoval).length || 0) }).map((_, index) => (
        <div
          key={`mobile-empty-opponent-drone-${index}`}
          style={{
            width: '80px',
            height: '60px',
            backgroundColor: '#333',
            border: '2px solid #555',
            borderRadius: '4px',
            opacity: 0.3
          }}
        />
      ))}
    </div>
  );
};

export default MobileOpponentDrones;

